import { render } from "./Collapse.vue?vue&type=template&id=1840bd02&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=ts"
export * from "./Collapse.vue?vue&type=script&lang=ts"

import "./Collapse.vue?vue&type=style&index=0&id=1840bd02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1840bd02"

export default script